export default function Audit({ data }) {
  const rows = Array.isArray(data) ? data : [];
  return (
    <section className="panel table-panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">TRACEABILITY</p>
          <h3>Audit history</h3>
          <p className="muted">Every action taken in the store workspace.</p>
        </div>
        <span className="record-count" data-testid="audit-record-count">{rows.length} events</span>
      </div>
      <div className="timeline">
        {rows.map((x, i) => (
          <div className="timeline-row" key={x.id || i} data-testid={`audit-row-${i}`}>
            <div className="timeline-dot" />
            <div>
              <strong>{x.action}</strong>
              <span>{x.detail}</span>
              <small>{x.actor} · {new Date(x.timestamp).toLocaleString()}</small>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="empty">Actions will appear here as you add or receive records.</div>}
      </div>
    </section>
  );
}
